/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const completeDrawing = (
  st: SpanTag,
  missionId: string,
  geojson,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${missionId}/drawing`);
  return fetchAPI(stleaf(st, 'chew0u'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(geojson),
  });
};

export const getState = (
  st: SpanTag,
  missionId: string,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${missionId}`);
  return fetchAPI(stleaf(st, 'aibah2'), url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getEvents = (
  st: SpanTag,
  missionId: string,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${missionId}/events`);
  return fetchAPI(stleaf(st, 'zai3al'), url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const accept = (
  st: SpanTag,
  missionId: string,
  snapshotId,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${missionId}/accept`);
  return fetchAPI(stleaf(st, 'zee4in'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({ snapshotId }),
  });
};

export const requestNewDrawing = (
  st: SpanTag,
  missionId: string,
): Promise<APIResponse> => {
  const url = new URL(
    `${config.API_URL}/v1/volumetric/${missionId}/event/allow_new_drawing`,
  );
  return fetchAPI(stleaf(st, 'apha1o'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
  });
};

interface RejectionOpts {
  contendedItems: Array<{ stockpileNo: number; text: string }>;
  revisionSnapshotId: string;
}

export const reject = (
  st: SpanTag,
  id: string,
  opts: RejectionOpts,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${id}/reject`);
  return fetchAPI(stleaf(st, 'poo3ch'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(opts),
  });
};

// ESK/Birdi only route for importing a revision (via shapefile)
export const importRevision = (
  st: SpanTag,
  id: string,
  blob,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${id}/revision`);
  return fetchAPI(stleaf(st, 'ku5the'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/octet-stream',
      Accept: 'application/json',
    },
    body: blob,
  });
};

// ESK/Birdi only route for importing final stockpile calculations (via shapefile)
export const importFinal = (
  st: SpanTag,
  id: string,
  blob,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/${id}/final`);
  return fetchAPI(stleaf(st, 'kufzhe'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/octet-stream',
      Accept: 'application/json',
    },
    body: blob,
  });
};

// Birdi only route for deleting event
export const deleteEvent = (
  st: SpanTag,
  eventId: string,
): Promise<APIResponse> => {
  const url = new URL(`${config.API_URL}/v1/volumetric/event/${eventId}`);
  return fetchAPI(stleaf(st, 'ic9jea'), url.toString(), {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/octet-stream',
      Accept: 'application/json',
    },
  });
};
